export {
  surveyTag,
  surveyMode,
  floatingSurveyPostLoginDelayMs,
} from '@rockalingua/shared/surveys/constants';

export const subQueryKey = 'surveys';
export const floatingSurveyQueryKey = 'floating';
